import { selectedElementAll } from "../utils/element-handlers.utils";

function GoToTopButtonComponent(goToTopButtonElement: HTMLElement) {
  goToTopButtonElement.addEventListener('click', function () {
    goToTopButtonElement.blur();
  });
}

export default function initGoToTopButtonComponent() {
  selectedElementAll('.n-go-to-top-button', GoToTopButtonComponent);
}
